module.exports = __webpack_public_path__ + "icon-close.png?5770202fecb1913aa90b351f127f1bba";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-close.png
// module id = 841
// module chunks = 1